import React, { Fragment } from 'react';
import { Certification } from '@mummssoftware/utils/constants';

import ReactQuill from 'react-quill';
import parse from 'html-react-parser';
import styled from 'styled-components';
import CertBodyGrid from './BodyGrid';
import { formatNarrativeVal, getFontSize } from './utils';
import { ApprovalEditor } from '../../Listing/Components';

import { modules, formats } from '../../../constants';

import 'react-quill/dist/quill.snow.css';

const QuillStyles = styled.div`
  font-size: ${(props) =>
    props.historicalView ? '18px !important' : 'inherit'};

  .ql-size-large {
    font-size: 2rem !important;
  }
  .ql-size-huge {
    font-size: 2.5rem !important;
  }
  .ql-size-small {
    font-size: 0.7rem !important;
  }
`;

const getEditorStyle = (disabled) =>
  disabled ? { ...modules, toolbar: false } : modules;

const CertNarrativeInput = ({
  alreadyCertified,
  captureNarrative,
  formatMessage,
  isDoctor,
  narrative,
  selectedCertIndex,
  submitting,
  takenBy,
  smallWidget,
  historicalView,
}) => (
  <Fragment>
    <ApprovalEditor>
      <ReactQuill
        key={`cert-${selectedCertIndex}`}
        id="narrative-field"
        preserveWhitespace
        readOnly={!isDoctor || alreadyCertified || submitting}
        style={{ fontSize: getFontSize(smallWidget, historicalView) }}
        theme="snow"
        onChange={captureNarrative('narrative')}
        value={
          alreadyCertified && !narrative
            ? formatNarrativeVal(formatMessage, takenBy)
            : narrative
        }
        modules={getEditorStyle(alreadyCertified)}
        formats={formats}
        placeholder="type something"
      />
    </ApprovalEditor>
  </Fragment>
);

export const CertNarrativeField = ({
  historicalView,
  narrative,
  inputProps,
  smallWidget,
  trailingMessage,
}) => (
  <Fragment>
    {/* historicalView used for ReactPDF snapshots. */}
    {historicalView ? (
      <CertBodyGrid
        typographyProps={{ color: 'textSecondary' }}
        smallWidget={smallWidget}
        historicalView={historicalView}
      >
        <QuillStyles historicalView={historicalView}>
          {parse(narrative)}
        </QuillStyles>
        {trailingMessage?.props?.children[0]?.slice(0, 13) !== Certification
          ? trailingMessage
          : null}
      </CertBodyGrid>
    ) : (
      <CertNarrativeInput
        narrative={narrative}
        smallWidget={smallWidget}
        historicalView={historicalView}
        {...inputProps}
      />
    )}
  </Fragment>
);
